import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Input, Row, Table } from 'reactstrap';
import i18n from '../../i18next';
import classnames from 'classnames';

import { loadJobPayload } from '../../actions/jobhistory/JobPayloadActions';
import { convertSecToMin, localizeStatuses, localizeActions } from '../../utils/CommonUtils';
import RestaurantUtils from '../../utils/RestaurantUtils';
import { SUCCESS, ONLINE, OFFLINE } from '../../utils/Constants';

class SubJobsDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedRow: 0,
            newRowSelected: false,
            stateAlreadyCopiedFromProps: false
        }
    }

    manageStateOnRender() {
        if (this.props.isOpen) {
            if (this.props.jobItems !== undefined && this.props.jobItems !== null && this.props.jobItems.length > 0
                && !this.state.newRowSelected && (!this.state.stateAlreadyCopiedFromProps
                    || (this.state.selectedRow !== 0 && this.props.jobItems[0].id !== this.state.selectedRow))) {

                this.copyStateFromProps();
            }
        } else {
            this.resetState();
        }
    }

    resetState() {
        this.setState({
            selectedRow: 0,
            stateAlreadyCopiedFromProps: false
        });
    }

    copyStateFromProps() {
        this.props.loadJobPayload(this.props.jobItems[0].id);

        this.setState({
            selectedRow: this.props.jobItems[0].id,
            stateAlreadyCopiedFromProps: true
        });
    }

    getJobPayload(jobId) {
        this.setState({
            selectedRow: jobId,
            newRowSelected: true
        });

        this.props.loadJobPayload(jobId);
    }

    renderTableRows() {
        const { rowText, cursorPointer } = styles;

        if (this.props.jobItems !== undefined && this.props.jobItems !== null) {

            return this.props.jobItems.map((item, i) => {

                const itemStatusChange = (item.status === SUCCESS) ? ONLINE : OFFLINE;
                const itemStatusColor = RestaurantUtils.getPosStatusColor(itemStatusChange);
                const statusColor = { color: itemStatusColor, fontSize: 12 };

                return (
                    <tr key={i}
                        className={"d-flex " + classnames({ active: this.state.selectedRow == item.id })}
                        onClick={() => this.getJobPayload(item.id)}
                        style={cursorPointer}>
                        <td className="col-1" style={rowText}>{item.id}</td>
                        <td className="col-2 longerNamesStyle" style={rowText}>{item.restaurantName}</td>
                        <td className="col-3" style={rowText}>{item.startedAt}</td>
                        <td className="col-2" style={rowText}>{convertSecToMin(item.duration)}</td>
                        <td className="col-2" style={rowText}>{localizeActions(item.action)}</td>
                        <td style={statusColor} className="col-2">{localizeStatuses(item.status)}</td>
                    </tr>
                );
            });
        } else {
            return <tr />;
        }
    }

    renderPayloadData() {
        const { textareaStyle, emptyTextAreaMsg } = styles;

        if ((this.props.jobPayload.length !== undefined && this.props.jobPayload.length > 0)
            || Object.keys(this.props.jobPayload).length > 0) {
            return (
                <Input type="textarea" name="text" value={JSON.stringify(this.props.jobPayload, null, 2)} style={textareaStyle} />
            );
        } else {
            return (
                <Input type="textarea" name="text" value={i18n.t('screens:jobDetailsScreen.noContent')} style={emptyTextAreaMsg} />
            );
        }
    }

    renderLoadingPayloadMessage() {
        const { emptyTextAreaMsg } = styles;

        return (
            <Input type="textarea" name="text" value={this.props.jobPayload} style={emptyTextAreaMsg} />
        );
    }

    render() {
        this.manageStateOnRender();

        const { zeroPadding, headerText, payloadText } = styles;

        return (
            <Col style={zeroPadding}>
                <p style={{ fontSize: 16, borderBottom: '1px solid #ced4db' }}>{i18n.t('screens:subJobsDetails.subJobs')} </p>
                <Table col={12} hover>
                    <thead>
                        <tr className="d-flex">
                            <th className="col-1" style={headerText}>{i18n.t('screens:jobsHistoryScreen.jobId')}</th>
                            <th className="col-2" style={headerText}>{i18n.t('screens:jobsHistoryScreen.restaurant')}</th>
                            <th className="col-3" style={headerText}>{i18n.t('screens:jobsHistoryScreen.startedAt')}</th>
                            <th className="col-2 longerNamesStyle" style={headerText}>{i18n.t('screens:jobsHistoryScreen.duration')}</th>
                            <th className="col-2" style={headerText}>{i18n.t('screens:jobsHistoryScreen.action')}</th>
                            <th className="col-2" style={headerText}>{i18n.t('screens:orderHistoryScreen.status')}</th>
                        </tr>
                    </thead>
                    <tbody>{this.renderTableRows()}</tbody>
                </Table>
                <Row>
                    <Col xs={12} sm={6} style={payloadText}>{i18n.t('screens:subJobsDetails.subJobId')} &nbsp; #{this.state.selectedRow} &nbsp;{i18n.t('screens:jobDetailsScreen.payload')}:</Col>
                    <Col xs={12} sm={12}>
                        {(this.props.jobPayload == i18n.t('actions:jobPayloadActions.loadingPayload')) ? this.renderLoadingPayloadMessage() : this.renderPayloadData()}
                    </Col>
                </Row>
            </Col>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

export default connect(mapStateToProps, { loadJobPayload })(SubJobsDetails);

const styles = {
    containerStyle: {
        width: '96%',
        marginTop: 20
    },
    zeroPadding: {
        paddingLeft: 0,
        paddingRight: 0
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    itemId: {
        color: '#0288D1',
        cursor: 'pointer'
    },
    textareaStyle: {
        height: 340
    },
    emptyTextAreaMsg: {
        height: 340,
        color: '#7c7c7c',
        fontStyle: 'italic'
    },
    payloadText: {
        marginBottom: 10,
        fontSize: 16
    },
    rowText: {
        fontSize: 12
    },
    headerText: {
        fontSize: 14
    },
    cursorPointer: {
        cursor: 'pointer'
    }
}


// WEBPACK FOOTER //
// ./src/components/jobhistory/SubJobsDetails.js